import React, { FC, useEffect, useCallback } from 'react'

import { Modal } from '../../atoms'

import styles from './_.module.css'

interface Props {
  modalVisibility: boolean
  setModalVisibility: (value: React.SetStateAction<boolean>) => void
  id: string
  returnHome: () => void
}

export const TabCloseModal: FC<Props> = ({
  modalVisibility,
  setModalVisibility,
  id,
  returnHome
}) => {
  const onTabClose = useCallback(() => {
    localStorage.setItem(`assignment_${id}_status`, 'FIN')
  }, [id])

  useEffect(() => {
    if (!id) {
      return
    }
    if (!modalVisibility) {
      window.addEventListener('onbeforeunload', onTabClose)
      window.addEventListener('beforeunload', onTabClose)
    } else {
      window.removeEventListener('onbeforeunload', onTabClose)
      window.removeEventListener('beforeunload', onTabClose)
    }
  }, [modalVisibility, onTabClose, id])

  useEffect(() => {
    window.addEventListener('storage', e => {
      if (e.key === `assignment_${id}_edited`) {
        setModalVisibility(true)
      }
    })

    const assignmentWritingStatus = localStorage.getItem(
      `assignment_${id}_status`
    )

    if (!assignmentWritingStatus || assignmentWritingStatus === 'FIN') {
      localStorage.setItem(`assignment_${id}_status`, 'WRI')
    } else {
      setModalVisibility(true)
    }
  }, [id, setModalVisibility])

  return (
    <Modal
      visible={modalVisibility}
      title="Duplicate version"
      okText="Go back"
      cancelText="Continue here"
      onOk={() => {
        setModalVisibility(false)
        returnHome()
      }}
      onCancel={() => {
        localStorage.setItem(`assignment_${id}_edited`, String(Math.random()))
        setModalVisibility(false)
      }}
      className={styles.tabOpenedModal}
    >
      <div>
        You have a duplicate version of this assignment open in another window
        or tab. If you wish to continue here, all your progress made there will
        be lost.
      </div>
    </Modal>
  )
}
